import {
  ApiFailoverAddress,
  apiFailoverAddressToAddress,
  FailoverAddress
} from "../../apiResponse/address";
import { AddressType, AppType } from "../../apiResponseHelpers";

/** This is following the old admin portal where the inbound call preference failover dropdown is bit more selective than the other failover dropdowns */
export const inboundFailoverAddressTypes: Array<AllAddressType> = [
  "adv_voicemailbox",
  "adv_queue",
  "adv_park",
  "adv_attendant_menu",
  "adv_dbn_directory",
  "adv_announcement",
  "telephone_number",
  "external",
  "group",
  "user",
  "time_switch",
  "contact_center"
];

export type AllAddressType = AddressType | AppType;

export declare interface ApiAddressSummary extends ApiFailoverAddress {
  AccountId: string;
  AppType: AppType; // voicemail, park, group, queue, etc
  Created: string;
  Modified: string;
  OrganizationId: string;
}

export declare interface AddressSummary extends FailoverAddress {
  accountId: string;
  organizationId: string;
  aor: string;
  addressType: AllAddressType;
}

export function apiAddressSummaryToAddressSummary(
  apiAddressSummary: ApiAddressSummary
): AddressSummary {
  return {
    ...apiFailoverAddressToAddress(apiAddressSummary),
    accountId: apiAddressSummary.AccountId,
    organizationId: apiAddressSummary.OrganizationId,
    aor: apiAddressSummary.Username + "@" + apiAddressSummary.Domain,
    addressType: apiAddressSummary.AppType || apiAddressSummary.Type || "" // shouldn't ever be empty
  };
}
